'use client';

import { toReadableDate } from '@/lib/dates';
import { getRelationFieldNames } from '@/requests/instanceMapper';
import {
  ApartmentListingApplicationViewingConfig,
  type ApartmentListingApplicationViewing,
} from '@pigello/pigello-matrix';
import type { RelationFieldProps } from './types';

export const ApartmentListingApplicationViewingItem: RelationFieldProps<ApartmentListingApplicationViewing> =
  {
    nested: getRelationFieldNames(ApartmentListingApplicationViewingConfig),
    renderItem: (item) => {
      const startTime = item.apartmentListingViewing?.startTime;
      return {
        title: startTime ? toReadableDate(startTime) : 'Visning',
        descriptionItems: (
          <div className='grid w-full'>
            <span>
              {startTime
                ? `Visning: ${toReadableDate(startTime)}`
                : `Skapad: ${toReadableDate(item.createdAt)}`}
            </span>
          </div>
        ),
      };
    },
  };
